import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import BackButton from '@/src/vueComponent/BackButton.vue'

import mySwal from '@/src/javascripts/plugins/mySwal.js'

$(document).on('turbo:load turbo:render', () => {
  const reportShow = document.querySelector('#report-show')
  if (reportShow && !reportShow.__vue_app__) {
    // 禁止 Ctrl + P
    document.addEventListener('keydown', (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
        e.preventDefault()
        // alert('列印功能已停用！')
        mySwal.error({ title: '列印功能已停用！' })
      }
    })
    // 禁止右鍵
    document.addEventListener('contextmenu', (e) => {
      return e.preventDefault()
    })

    createApp({
      components: { BaseAlert, BackButton },
      setup () {
        return {}
      }
    }).mount(reportShow)
  }
})
